import background from '../assets/img/6039257.jpg'
import backgroundBusiness from '../assets/img/business-meeting.jpg'
import { AdviseLabels } from '../enums/MessageEnum'
import '../assets/styles/hero.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUserTie, faUsers, faBusinessTime, faEarth } from '@fortawesome/free-solid-svg-icons'
import CountUp from 'react-countup';
import { useEffect, useState } from 'react'

export default function Carrousel(){

    const [bkgImage, setBkgImage] = useState(background)

    const statsData = [
        {
            name: AdviseLabels.STATISTICS_ANIOS_EXPERIENCIA_TITLE,
            value: AdviseLabels.STATISTICS_ANIOS_EXPERIENCIA_VALUE,
            icon: faUserTie
        },
        {
            name: AdviseLabels.STATISTICS_CLIENTES_TITLE,
            value: AdviseLabels.STATISTICS_CLIENTES_VALUE,
            icon: faUsers
        },
        {
            name: AdviseLabels.STATISTICS_CASOS_EXITO_TITLE,
            value: AdviseLabels.STATISTICS_CASOS_EXITO_VALUE,
            icon: faBusinessTime
        },
        {
            name: AdviseLabels.STATISTICS_INTERNACIONAL_TITLE,
            value: AdviseLabels.STATISTICS_INTERNACIONAL_VALUE,
            icon: faEarth
        }
    ]

    const handleScroll = () => {
        const targetDiv = document.getElementById('products');
        if(!targetDiv.getBoundingClientRect()) return
        
        const targetDivTop = targetDiv.getBoundingClientRect().top;
        setBkgImage(targetDivTop > 0 ? background : backgroundBusiness)
    };
        
    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
    
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    return(
        <div className="flex flex-column bg-gradient-to-r from-purple-600 to-blue-600 text-white overflow-hidden"
                style={{minHeight: "100vh"}}>
            <div className="fixed inset-0 hero-background">
                <img className="w-full min-h-full object-cover" 
                src={bkgImage} alt="Background" />
                <div className="fixed inset-0 bg-black opacity-50"></div>
            </div>
            <div className="relative z-10 flex flex-col justify-center items-center min-h-full text-center">
                <h1 className="text-5xl font-bold leading-tight mb-4 hero-text" 
                    style={{ animationDelay: '0.35s', paddingTop: "10vh" }}>
                    {AdviseLabels.HERO_TITLE}
                </h1>
                <p className="text-lg text-gray-300 mb-2 hero-text" style={{width: "65%", paddingBottom: "2vh", 
                    fontSize: "24px", animationDelay: '0.45s'}}>{AdviseLabels.HERO_MESSAGE}</p>
                <div className="statistics-container hero-text" style={{animationDelay: '0.55s'}}>
                {
                    statsData.map(function(index, value) {
                        return(
                            <div className='statistics-container-internal' key={index.name + value}>
                                <div className='statistics-image'>
                                    <FontAwesomeIcon icon={index.icon} className='fa-4x'/>
                                </div>
                                <div className='statistics-data'>
                                    <CountUp
                                        start={value === 0 ? new Date().getFullYear() : 0}
                                        separator={""}
                                        end={index.value}
                                        duration={2}
                                        prefix={value === 0 ? '' : '+'}
                                        delay={0.55}
                                        className='statistics-number'
                                    />
                                    <div className='statistics-label'>{index.name}</div>
                                </div>
                            </div>
                        )
                    })
                }
                </div>
                <div className='hero-button-container'>
                    <a href="#contact-us" className="bg-blue-400 text-gray-900 hover:bg-blue-300 
                    py-4 px-12 rounded-full text-lg font-semibold transition duration-300 
                    ease-in-out transform hover:scale-105 hover:shadow-lg hero-button">
                        Contáctenos
                    </a>
                </div>         
            </div>
        </div>

    )
}